const formatCurrency = (value) => `$${(value / 100).toFixed(2)}`
const formatCurrencyTruncated = (value) => `$${(value / 100).toFixed(0)}`

export default formatCurrency

export { formatCurrency, formatCurrencyTruncated }
